import { defineComponent, inject, onMounted, createVNode } from "vue";
import { getPrefixCls } from "../_utils/global-config.js";
import usePropOrSlot from "../_utils/use-prop-or-slot.js";
import { cardInjectionKey } from "./context.js";
var _CardMeta = defineComponent({
  name: "CardMeta",
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    }
  },
  setup(props, {
    slots
  }) {
    const prefixCls = getPrefixCls("card-meta");
    const titleRef = usePropOrSlot(props, slots, "title");
    const descRef = usePropOrSlot(props, slots, "description");
    const context = inject(cardInjectionKey);
    onMounted(() => {
      if (context) {
        context.hasMeta = true;
      }
    });
    return {
      computedTitle: titleRef,
      computedDesc: descRef,
      prefixCls,
      context,
      slots
    };
  },
  render() {
    const {
      computedTitle,
      computedDesc,
      prefixCls,
      context,
      slots
    } = this;
    const {
      actions
    } = context || {};
    return createVNode("div", {
      "class": prefixCls
    }, [computedTitle || computedDesc ? createVNode("div", {
      "class": `${prefixCls}-content`
    }, [computedTitle && createVNode("div", {
      "class": `${prefixCls}-title`
    }, [computedTitle]), computedDesc && createVNode("div", {
      "class": `${prefixCls}-description`
    }, [computedDesc])]) : null, slots.avatar || actions ? createVNode("div", {
      "class": [`${prefixCls}-footer `, {
        [`${prefixCls}-footer-only-actions`]: !slots.avatar
      }]
    }, [slots.avatar ? createVNode("div", {
      "class": `${prefixCls}-avatar`
    }, [slots.avatar()]) : null, actions]) : null]);
  }
});
export { _CardMeta as default };
